import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductsWithFilters from "./ProductsWithFilters";
import NewProductPopUp from "./NewProductPopUp";
import "./Products.scss";
import { getAllCategory } from "../../../server/Category";

const Products = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();
  const stationId = useSelector((state) => state.user.stationId);

  useEffect(() => {
    dispatch(getAllCategory(stationId, null, 4, true, true));
  }, [stationId, dispatch]);

  return (
    <div className="products-header">
      <ProductsWithFilters openModal={() => setIsModalOpen(true)} />
      <NewProductPopUp
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Products;
